import { MiscHelperService } from './../../../../sdk/services/custom/miscHelperService.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from './../../../../sdk/services/core/auth.service';
import { url } from './../../../cloudFrontUrl'
import { Component, OnInit, Input, OnChanges, EventEmitter, Output, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { ListingApi } from './../../../../sdk/services/custom/listing.service';

@Component({
  standalone: true,
  selector: 'app-favourite-property-list',
  imports: [CommonModule, RouterModule, NzGridModule],
  templateUrl: './favourite-property-list.component.html',
  styleUrls: ['./favourite-property-list.component.scss'],
})
export class FavouritePropertyListComponent implements OnInit, OnDestroy {
 @ViewChild('PropertyCompleteProgessHost', { read: ViewContainerRef, static: false }) public PropertyCompleteProgessHost: ViewContainerRef;
  PropertyCompleteProgessContainer;
  assetUrl: string;
 
  constructor(
    private authService: AuthService,
    private listingApi: ListingApi,
    private miscHelperService: MiscHelperService,
    private message: NzMessageService) {
    this.assetUrl = url;
  }
  @Input() nz_span = 8;
  @Input() remove_padding = false;
  @Input() display_type = 'grid-view';
  @Input() type = 'Sale';
  @Input() data;
  @Input() page = 'listing';
  @Input() displayHeart = false;
  @Input() propertyOwner = false;
  @Input() loggedIn = false;
  @Input() showListingStatus = false;
  routerUrlLink;
  @Input() favoritesComponent = false;
  @Input() heartColor = 'white';
  @Input() showTag = false;
  isAdmin = false;
  @Output() output = new EventEmitter();
  nzLgVar = { span: 6, offset: 0 };
  percentage_fields = 0;

  nzLg = 24;
  nzMd = 12;
  nzXs = 6;
  property_detail;
  user_id;
  @Input() status = false;
  current_user_email : any;

  ngOnInit() {
    const { id, role,email } = this.authService.getAccessTokenInfo();
    this.user_id = id;
    this.current_user_email = email;
    console.log(this.current_user_email);
    if (this.data && this.data.listing_images_thumb) {
      const detail = this.data.listing_images_thumb.filter((obj) => {
        return obj.display === true;
      });
      this.property_detail = detail[0];
    }
    if (!this.favoritesComponent){
      //this.loadPropertyCompleteProgess();
    }

  }
  ngOnDestroy() {
    this.PropertyCompleteProgessHost?.clear();
  }

  updateHeartColor() {
    if (this.status === true) {
      this.heartColor = '#47c0bb';
    } else {
      this.heartColor = 'white';
    }
  }
  ngOnChanges() {
    if (this.loggedIn) {
      const { id, role,email } = this.authService.getAccessTokenInfo();
      this.user_id = id;
      this.current_user_email = email;
      this.authService.getAccessTokenInfo();
      this.user_id = id;
      const userIdExists = (obj) => obj.user_id === id;
      if (this.data.favorites) {
        if (this.data.favorites.some(userIdExists)) {
          this.status = true;
          this.updateHeartColor();
        }
      }
    }
    if (this.data) {
      if (this.data.address) {
        if (!this.isAdmin) {
          let slug = this.miscHelperService.slugifyUrl(
            this.data.address.address,
            this.data._id
          );
          this.routerUrlLink = `/listings/${slug}`;
        } else {
          this.routerUrlLink = `/admin/listings/listing-${this.data._id}`;
        }
      }
      if (this.data.completeness) {
        this.percentage_fields = this.data.completeness.percentage_fields;
        // console.log(' this.percentage_fields', this.percentage_fields)
      }
      this.type = this.data.listing_status?.status;
      if (this.nz_span) {
        this.nzLgVar = { span: this.nz_span, offset: 0 };
      }
      // if (this.data.mls_fee) {
      //   this.type = 'In Review';
      //   // paid
      // } else {
      //   this.type = 'Incomplete';
      // }
    }

    this.nzLg = null;
    this.nzMd = null;
    this.nzXs = null;
  }
  openNewTab() {
    if (this.page !== 'listing') {
      const tempUrl = window.location.href;
      const finalUrl = tempUrl + '/' + this.routerUrlLink;
      window.open(finalUrl, 'blank');
    }
  }
  getListingAgain() {
    this.output.emit(null);
    this.message.success('Property has been removed from favorites', {
      nzDuration: 3500,
    });
  }
  favouriteClick(e) {
    e.stopPropagation();
    this.listingApi
      .updateListingFavorite(this.data._id, this.user_id, !this.status)
      .subscribe(
        (data) => {
          if (this.favoritesComponent) {
            this.getListingAgain();
            this.status = !this.status;
          } else {
            this.status = !this.status;
            this.updateHeartColor();
            if (this.status) {
              this.message.success('Property has been added to favorites', {
                nzDuration: 3500,
              });
            } else {
              this.message.success('Property has been removed from favorites', {
                nzDuration: 3500,
              });
            }
          }
        },
        (error) => {
          console.log('error', error);
          // const { message } = error.error;
          // this.message.error(message, {
          //   nzDuration: 3500
          // });
        }
      );
  }
  loadPropertyCompleteProgess(){
    import('./../property-complete-progress/property-complete-progress.module').then(({ PropertyListItemComponentModule }) => {
      const NewPropertyListItemComponent = PropertyListItemComponentModule.getPropertyCompleteProgress();
      const factory = NewPropertyListItemComponent;
      this.PropertyCompleteProgessHost?.clear();
      this.PropertyCompleteProgessContainer = this.PropertyCompleteProgessHost.createComponent(factory);
      this.PropertyCompleteProgessContainer.instance.listing_detail = this.data;
      // this.PropertyCompleteProgessContainer.instance.is_seller_2 = this.data?.is_seller_2;
      // this.PropertyCompleteProgessContainer.instance.document_completeness = this.data?.document_completeness;
      // this.PropertyCompleteProgessContainer.instance.percentage_fields = this.percentage_fields;
      this.PropertyCompleteProgessContainer.instance.from_list = true;
    });  
  }
}